"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _LegendItem = _interopRequireDefault(require("./LegendItem"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
require("./ChartLegend.css");
var styles = {
  "chart-legend": "ChartLegend__chart-legend___1kUYv",
  "disable-click": "ChartLegend__disable-click___2hv9J",
  "enable-hover": "ChartLegend__enable-hover___hyh23",
  "chartLegend": "ChartLegend__chart-legend___1kUYv",
  "disableClick": "ChartLegend__disable-click___2hv9J",
  "enableHover": "ChartLegend__enable-hover___hyh23"
};
var ChartLegend = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(ChartLegend, _React$PureComponent);
  function ChartLegend(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ChartLegend);
    _this = _callSuper(this, ChartLegend, [props]);
    _this.onLegendItemHover = _this.onLegendItemHover.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onLegendItemBlur = _this.onLegendItemBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onLegendItemClick = _this.onLegendItemClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(ChartLegend, [{
    key: "onLegendItemClick",
    value: function onLegendItemClick(legendItemIndex) {
      var _this$props = this.props,
        disableLegendOnClick = _this$props.disableLegendOnClick,
        onLegendItemClick = _this$props.onLegendItemClick;
      if (!disableLegendOnClick) {
        onLegendItemClick(legendItemIndex);
      }
    }
  }, {
    key: "onLegendItemHover",
    value: function onLegendItemHover(legendItemIndex) {
      this.changeHoveredLegendItemIndex(legendItemIndex);
    }
  }, {
    key: "onLegendItemBlur",
    value: function onLegendItemBlur() {
      this.changeHoveredLegendItemIndex(undefined);
    }
  }, {
    key: "changeHoveredLegendItemIndex",
    value: function changeHoveredLegendItemIndex(legendItemIndex) {
      var _this$props2 = this.props,
        disableLegendOnHover = _this$props2.disableLegendOnHover,
        onHoveredLegendItemIndexChange = _this$props2.onHoveredLegendItemIndexChange,
        activeSeriesIndexSet = _this$props2.activeSeriesIndexSet;
      if (!disableLegendOnHover && (legendItemIndex === undefined || activeSeriesIndexSet.has(legendItemIndex))) {
        onHoveredLegendItemIndexChange(legendItemIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        activeSeriesIndexSet = _this$props3.activeSeriesIndexSet,
        focusedSeriesIndex = _this$props3.focusedSeriesIndex,
        colors = _this$props3.colors,
        labels = _this$props3.labels,
        disableLegendOnClick = _this$props3.disableLegendOnClick,
        disableLegendOnHover = _this$props3.disableLegendOnHover;

      // Enable hover effect for active series and enabled effect for the legend
      var isActiveFocusedSeries = activeSeriesIndexSet === undefined || activeSeriesIndexSet.has(focusedSeriesIndex);
      var enableHoverEffect = !disableLegendOnHover && isActiveFocusedSeries;
      var classes = (0, _classnames["default"])(styles.chartLegend, enableHoverEffect && styles.enableHover, disableLegendOnClick && styles.disableClick);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes
      }, labels.map(function (label, index) {
        return /*#__PURE__*/_react["default"].createElement(_LegendItem["default"], {
          key: index,
          itemIndex: index,
          label: label,
          active: activeSeriesIndexSet === undefined || activeSeriesIndexSet.has(index),
          color: colors[index % colors.length],
          onHover: _this2.onLegendItemHover,
          onBlur: _this2.onLegendItemBlur,
          onClick: _this2.onLegendItemClick
        });
      }));
    }
  }]);
  return ChartLegend;
}(_react["default"].PureComponent);
(0, _defineProperty2["default"])(ChartLegend, "defaultProps", {
  activeSeriesIndexSet: undefined,
  focusedSeriesIndex: undefined,
  onLegendItemClick: function onLegendItemClick() {},
  onHoveredLegendItemIndexChange: function onHoveredLegendItemIndexChange() {},
  disableLegendOnClick: false,
  disableLegendOnHover: false
});
//# sourceMappingURL=ChartLegend.js.map